import React, { useState } from 'react';
import { Editor } from './Editor';

export function safeParseBody(val) {
  if (!val) return { blocks: [] };
  if (typeof val === 'object') return val;
  try {
    const parsed = JSON.parse(val);
    return typeof parsed === 'object' && parsed !== null ? parsed : { blocks: [] };
  } catch {
    return { blocks: [] };
  }
}

const TYPE_STYLES = `
  .rte-toolbar {
    display: flex;
    gap: 4px;
    margin-bottom: 6px;
  }
  .rte-type-btn {
    padding: 2px 10px;
    font-size: 0.78rem;
    border: 1px solid var(--border-color, #ccc);
    background: transparent;
    border-radius: 4px;
    cursor: pointer;
    color: inherit;
    opacity: 0.6;
  }
  .rte-type-btn.active {
    background: var(--purple, #313b72);
    color: #fff;
    border-color: var(--purple, #313b72);
    opacity: 1;
  }
  .rte-markdown-editor {
    font-family: 'Courier New', monospace;
    font-size: 0.9rem;
    resize: vertical;
    min-height: 200px;
    width: 100%;
    box-sizing: border-box;
  }
`;

function RichTextEditor({ value, type = 'editorjs', onChange, onTypeChange, websiteId }) {
  const [editorKey, setEditorKey] = useState(0);
  const [editorData] = useState(() => {
    const body = safeParseBody(value);
    return { time: Date.now(), blocks: body.blocks || [] };
  });

  const handleTypeChange = (newType) => {
    if (newType === type) return;
    if (newType === 'editorjs') setEditorKey(k => k + 1);
    onTypeChange?.(newType);
  };

  return (
    <div>
      <style>{TYPE_STYLES}</style>
      <div className="rte-toolbar">
        <button
          type="button"
          className={`rte-type-btn${type === 'editorjs' ? ' active' : ''}`}
          onClick={() => handleTypeChange('editorjs')}
        >
          Editor.js
        </button>
        <button
          type="button"
          className={`rte-type-btn${type === 'markdown' ? ' active' : ''}`}
          onClick={() => handleTypeChange('markdown')}
        >
          Markdown
        </button>
      </div>

      {type === 'markdown' ? (
        <textarea
          className="form-control rte-markdown-editor"
          rows={12}
          value={typeof value === 'string' ? value : ''}
          onChange={(e) => onChange?.(e.target.value)}
          placeholder="Enter markdown…"
        />
      ) : (
        <Editor key={editorKey} data={editorData} onChange={onChange} websiteId={websiteId} />
      )}
    </div>
  );
}

export default RichTextEditor;
